import React from 'react';
import { CSVLink } from 'react-csv';
import FontAwesomeIcon from 'src/components/Icon';
import './DownloadReportButton.scss';

export interface DownloadReportButtonHeader {
  label: string;
  key: string;
}

export interface DownloadReportButtonProps {
  data: any[];
  headers: DownloadReportButtonHeader[];
  filename: string;
  title?: string;
}

export const DownloadReportButton = ({
  data,
  headers,
  filename,
  title = 'Download Report',
}: DownloadReportButtonProps) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className="download-report-button">
      <CSVLink
        data={data}
        asyncOnClick={true}
        headers={headers}
        separator={','}
        filename={filename}
      >
        <div className="download-report-button__content">
          <div className="download-report-button__label">{title}</div>
          <FontAwesomeIcon glyph="cloud-download" weight="regular" size="big" />
        </div>
      </CSVLink>
    </div>
  );
};
